import React, { useContext } from 'react'
import styled from 'styled-components'
import { Relative, Absolute, BackgroundImage } from 'pcln-design-system'
import BootstrapDataContext from '../../context/BootstrapDataContext'

const StyledContent = styled(Relative)`
  max-width: 1280px;
  margin: 0 auto;
`

const StyledBackgroundImage = styled(BackgroundImage)<{
  isTablet: boolean
  backgroundPosition?: string
}>`
  background-color: #024fb2;
  background-position: ${props => props.backgroundPosition ?? 'top left'};
  background-attachment: ${props => (props.isTablet ? 'unset' : 'fixed')};
  ${props => props.theme.mediaQueries[3]} {
    background-position: ${props => props.backgroundPosition ?? 'top right'};
  }
`

type HeroProps = {
  img: string
  children: JSX.Element
  description?: string
  backgroundPosition?: string
}

export default function Hero({
  img,
  children,
  description = 'Hero background Image'
}: HeroProps) {
  const { isTablet = false } = useContext(BootstrapDataContext)
  return (
    <Relative>
      <StyledContent zIndex={10} pt={4} pb="40px" px={4}>
        {children}
      </StyledContent>
      <Absolute bottom={0} left={0} right={0} top={0}>
        <StyledBackgroundImage
          image={img}
          height="100%"
          alt={description}
          isTablet={isTablet}
          className="hero-image"
        />
      </Absolute>
    </Relative>
  )
}
